
































import Api from "@/api/Api";
import { Advertisement } from "@/interfaces/advertisement";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    async exec() {
      if (!this.advertisement) {
        return;
      }

      const created = await Api.singleton().call({
        method: "POST",
        resource: "/api/adv/posts/duplicate/from/" + this.advertisement.id
      });
      this.$emit("success", created);
    }
  }
});
